import { devEnv, INVESTMENT_PROFILE_BACKEND_URL } from 'services/constants';
import axios, { AxiosError } from 'axios';
import { CIPInfo } from 'views/BrTabs/BrTabs';

const axiosInstance = axios.create({ withCredentials: devEnv });

const getInvestmentProfileState = async (brUid: string): Promise<CIPInfo> => {
  const response = await axiosInstance
    .get(`${INVESTMENT_PROFILE_BACKEND_URL}/api/business-relationship/${brUid}/cipinfo`)
    .catch((error: AxiosError) => {
      throw error;
    });

  return response.data;
};

const investmentProfileService = { getInvestmentProfileState };
export default investmentProfileService;
